import React, { useEffect, useState } from 'react';
import Header from './Header';
import Tabs from './Tabs';
import RightPanel from './RightPanel';
import { Dialog, DialogContent } from '../../ui/dialog';
import { cn } from '../../../helpers/shadcnUtils.helper';

interface ContentLayoutProps {
  className?: string;
  title?: string | JSX.Element;
  description?: string | JSX.Element;
  subDescription?: string | JSX.Element;
  subtitle?: string | JSX.Element;
  middleContent: JSX.Element;
  adjacentTitleButtons?: JSX.Element | null;
  currentTabRoutes?: Array<{ path: string; code: string }>;
  topContent?: JSX.Element;
  topRightAdjacentContent?: JSX.Element;
  rightPannelclassName?: string;
  isLoadingData?: boolean;
  isLoadingRigthData?: boolean;
  isError?: boolean;
  errorText?: string;
  element?: JSX.Element | null;
  placeHolder?: JSX.Element | null;
  isShowingBackButton?: boolean;
  closeAction?: () => void;
  badgeInfo?: {
    label?: string;
    upperLabel?: string;
    colorClass?: string;
  };
  complementaryInformation?: JSX.Element | null;
  iconBox?: JSX.Element;
}

const MOBILE_BREAK_POINT = 768;
const LARGE_BREAK_POINT = 992;

const ContentLayoutComponent: React.FC<ContentLayoutProps> = ({
  title,
  description,
  subDescription,
  subtitle,
  middleContent,
  adjacentTitleButtons,
  currentTabRoutes,
  topContent,
  topRightAdjacentContent,
  isLoadingData = false,
  isError = false,
  errorText,
  isLoadingRigthData,
  element,
  placeHolder,
  closeAction,
  isShowingBackButton,
  badgeInfo,
  className,
  iconBox,
  rightPannelclassName,
  complementaryInformation,
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(
    window.innerWidth < MOBILE_BREAK_POINT ||
      (!!isShowingBackButton && window.innerWidth < LARGE_BREAK_POINT),
  );

  // 🖥️ Gestion du redimensionnement
  useEffect(() => {
    const handleResize = () =>
      setIsMobile(
        window.innerWidth < MOBILE_BREAK_POINT ||
          (!!isShowingBackButton && window.innerWidth < LARGE_BREAK_POINT),
      );
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
      {' '}
      {isMobile && element && (
        <Dialog modal open={!!element && isMobile} onOpenChange={closeAction}>
          <DialogContent fullScreen>
            <RightPanel
              element={element}
              placeHolder={placeHolder}
              closeAction={closeAction}
              isLoadingData={isLoadingRigthData}
              badgeInfo={badgeInfo}
              description={description}
              subDescription={subDescription}
              iconBox={iconBox}
              isShowingBackButton={!!isShowingBackButton}
              className={rightPannelclassName}
              complementaryInformation={complementaryInformation}
            />
          </DialogContent>
        </Dialog>
      )}
      <div
        className={`flex flex-col gap-6 lg:grid lg:grid-cols-12 w-full bg-neutral-98  md:mr-12 ${className}  `}
      >
        {/* Section Principale */}
        <div
          className={cn(
            { 'lg:col-span-7': element || placeHolder || isLoadingRigthData },
            {
              'lg:col-span-12 ': !element && !placeHolder && !isLoadingRigthData,
            },
            { 'hidden lg:block': element && !isMobile },
          )}
        >
          <div className="relative h-full">
            <div
              id="scrollableContainer"
              className="h-full  px-2  max-h-[calc(100vh-64px)]  overflow-x-hidden overflow-y-auto md:px-4 xxl:px-0 max-sm:pb-14 md:pt-9 pt-4 "
            >
              <Header
                title={title ?? ''}
                adjacentTitleButtons={adjacentTitleButtons}
                subtitle={subtitle}
              />

              {topContent && <div className="mb-4">{topContent}</div>}

              {currentTabRoutes && currentTabRoutes.length > 0 && (
                <Tabs currentTabRoutes={currentTabRoutes} t={(key) => key} />
              )}

              <div>{middleContent}</div>
            </div>
          </div>
        </div>
        {!isMobile && !!(element || placeHolder || isLoadingRigthData) && (
          <div className="px-0 lg:col-span-5 md:px-4 lg:px-0">
            <RightPanel
              element={element}
              placeHolder={placeHolder}
              closeAction={closeAction}
              isLoadingData={isLoadingRigthData}
              badgeInfo={badgeInfo}
              description={description}
              subDescription={subDescription}
              iconBox={iconBox}
              className={rightPannelclassName}
              complementaryInformation={complementaryInformation}
            />
          </div>
        )}
      </div>
    </>
  );
};

const ContentLayout = React.memo(ContentLayoutComponent);
export { ContentLayout };
